var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructionsUserStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:mountains-fill",
    clipPath: "url(#clip0_3549_45082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7497 4.875C12.7497 4.35583 12.9037 3.84831 13.1921 3.41663C13.4805 2.98495 13.8905 2.6485 14.3702 2.44982C14.8498 2.25114 15.3776 2.19915 15.8868 2.30044C16.396 2.40173 16.8637 2.65173 17.2309 3.01885C17.598 3.38596 17.848 3.85369 17.9493 4.36289C18.0505 4.87209 17.9986 5.39989 17.7999 5.87955C17.6012 6.3592 17.2647 6.76917 16.8331 7.05761C16.4014 7.34605 15.8939 7.5 15.3747 7.5C14.6785 7.5 14.0108 7.22344 13.5185 6.73116C13.0263 6.23887 12.7497 5.57119 12.7497 4.875ZM23.9059 19.125C23.8399 19.2393 23.7449 19.3342 23.6305 19.4C23.5161 19.4659 23.3864 19.5004 23.2544 19.5H0.749699C0.61752 19.4999 0.487702 19.465 0.373396 19.3986C0.259089 19.3322 0.164353 19.2368 0.0987844 19.122C0.0332155 19.0073 -0.000857574 18.8772 1.63993e-05 18.745C0.000890373 18.6129 0.0366804 18.4833 0.103761 18.3694L6.95689 6.73875C7.08935 6.51362 7.27831 6.32699 7.50506 6.19731C7.73181 6.06764 7.98849 5.99943 8.2497 5.99943C8.51091 5.99943 8.76759 6.06764 8.99434 6.19731C9.22109 6.32699 9.41005 6.51362 9.54251 6.73875L13.7463 13.875L16.1988 9.73688C16.3302 9.51166 16.5186 9.325 16.7451 9.19565C16.9715 9.06631 17.228 8.99883 17.4888 9C17.7495 8.99867 18.006 9.06586 18.2325 9.19486C18.4591 9.32385 18.6478 9.51012 18.7797 9.735L23.8947 18.3675C23.9636 18.4814 24.001 18.6116 24.003 18.7447C24.005 18.8779 23.9715 19.0091 23.9059 19.125ZM6.04001 11.25H10.4594L8.2497 7.5L6.04001 11.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3549_45082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsUserStory);
export default __webpack_public_path__ + "static/media/InstructionsUserStory.c2ad79dfe870543c40c97a22fa720e7f.svg";
export { ForwardRef as ReactComponent };